export default __webpack_public_path__ + "static/media/image-cushion-g-w.efb26275.webp";